import React from 'react'
import {StaticQuery, graphql} from 'gatsby'
import Img from 'gatsby-image'

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        file(relativePath: { eq: "contact@2x.png" }) {
          childImageSharp {
            fluid(maxWidth: 2000, quality: 100) {
               ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => <Img fluid={data.file.childImageSharp.fluid} {...props} />}
  />
)
